//////////////////////////////////////////////////////////////////////////////
//
//  Exercise Video Watch History API
//
//  작성자: MediInStep Team
//  생성일: 2025-12-26
//
//  설명: 운동 영상 시청 이력 관련 API 정의
//
//////////////////////////////////////////////////////////////////////////////

import { ApiGroup } from "../types/ApiTypes"

/**
 * 운동 영상 시청 이력 관련 API
 */
const ExerciseVideoWatchHistoryAPI: ApiGroup = {
    pagedList: {
        title: "영상 시청 이력 목록 조회",
        url: "/ExerciseVideoWatchHistory/PagedList",
        method: "POST",
        paramz: {},
    },
}

export default ExerciseVideoWatchHistoryAPI

// TypeScript Interfaces
export interface ExerciseVideoWatchHistoryCriteria {
    pageNumber: number;
    pageSize: number;
    userSeqId?: number;
    videoSeqId?: number;
    watchDateFrom?: string; // YYYY-MM-DD
    watchDateTo?: string; // YYYY-MM-DD
    isCompleted?: boolean;
    isRewarded?: boolean;
    userName?: string;
    videoTitle?: string;
}

export interface ExerciseVideoWatchHistoryDTO {
    watchSeqId?: number;
    userSeqId: number;
    userName?: string;
    userEmail?: string;
    videoSeqId: number;
    videoTitle?: string;
    videoDurationSec?: number;
    watchDate: string; // YYYY-MM-DD
    isCompleted: boolean;
    completedAt?: string;
    maxWatchedSeconds: number;
    isRewarded?: boolean;
    rewardPoints?: number;
    pointTransactionSeqId?: number;
    startedAt: string;
    crtDt: string;
    edtDt?: string;
    completionPercentage?: number;
}

export interface ExerciseVideoWatchHistoryPagedResult {
    items: ExerciseVideoWatchHistoryDTO[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
}
